export const SHOW_SPECIAL_ANIMATION = true;
export const SPECIAL_BACKGROUND_COLOR = "#A6E0F2";
